export const enSendbar = {
    translation: {
        "Enviar una plantilla": "Send a template",
        'Plantilla':'Template',
        'Seleccione una opción':'Select an option',
        'Enviar':'Send',
        'Tú':'You',
        'Entregado':'Delivered',
    }
}